import { getTokenAsync } from "../../../hooks/API/getAuthToken";
import { makeHeaders } from "../tools";
import { DATA_SERVICE_URL } from "../../../hooks/API/data.service";
import { sanitiseDots } from "@coworker/app/src/helpers/utils";
import { CombinationProducts } from "../types/article";
import { formatCombinationNumber } from "@coworker/apprestructured/src/scan-and-search/helpers/searchUtils";
import { LocalCombinationItem } from "@coworker/apprestructured/src/shared/types/localCombinationItem";

const BASE_URL = DATA_SERVICE_URL + "/local-combinations";

export const searchCombinationNameOrId = async (
  storeId: string,
  text: string
) => {
  try {
    const token = await getTokenAsync();
    if (!token || typeof token !== "string") {
      return;
    }

    const searchResponse = await fetch(`${BASE_URL}/searchLocalCombination`, {
      method: "POST",
      headers: makeHeaders(token),
      body: JSON.stringify({ storeId, text: sanitiseDots(text) }),
    });

    if (!searchResponse.ok) {
      throw new Error("Network response was not ok.");
    }

    return (await searchResponse.json()) as CombinationProducts[];
  } catch (error) {
    console.error("Fetch error:", error);
  }
  return null;
};

export const fetchItemsInfoFromDataService = async (
  storeId: string,
  userCountryId: string,
  articleNumber: string
) => {
  try {
    const token = await getTokenAsync();
    if (!token || typeof token !== "string") {
      return;
    }

    const response = await fetch(
      `${BASE_URL}/getLocalCombinations?combinationNumbers=${articleNumber}&storeId=${storeId}`,
      {
        method: "GET",
        headers: makeHeaders(token),
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok.");
    }

    const combinationResponse = ((await response.json()) ||
      []) as CombinationProducts[];

    return combinationResponse.map((itemsInfoResponse) => ({
      name:
        itemsInfoResponse.combinationNames.find(
          (name) => name.country_code === userCountryId
        )?.combination_name || "",
      no: itemsInfoResponse.combinationNumber || "",
      type: itemsInfoResponse.combinationType || "",
      noFormatted: formatCombinationNumber(itemsInfoResponse.combinationNumber),
      description: "",
      productTypeName: "",
      paNo: "",
      hfbNo: "",
      source: "data-service",
      outgoing: false,
      smallImageUrl: "",
      imageUrl: "",
      itemsCountInCombination: itemsInfoResponse.articlesCount || 0,
      itemsInCombination: itemsInfoResponse.articleCombinations || [],
    })) as unknown as LocalCombinationItem[];
  } catch (error) {
    console.error("Fetch error:", error);
  }
  return [];
};
